type PropTypes = {
  className?: string
}

const DownCaret = ({ className }: PropTypes) => {
  return (
    <svg
      width="16"
      height="17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="m12 6.411-4 5-4-5h8Z"
        fill="currentColor"
      />
    </svg>
  )
}

export default DownCaret
